module.exports = __webpack_public_path__ + "img/subcontractors_introduction.308837ad.svg";